import { gql, request } from "graphql-request";
import { baseUrl } from 'services/shared/Environment'

function signupSubscriberMutation(args: {
  email: string;
  signupReferralCode?: string;
}) {
  const { email, signupReferralCode } = args;
  return gql`
    mutation {
      signupSubscriber(email: "${email}", signupReferralCode: "${signupReferralCode}") {
        id
      }
    }
  `;
}

export function useSignupSubscriber() {

  async function signupSubscriber(email: string): Promise<{
    subscriberSignedUp?: boolean;
    subscriberId?: string;
    signupSubscriberError?: string;
  }> {
      try {
        const result = await request(`${baseUrl()}/api/graphql`, signupSubscriberMutation({ email }));
        const subscriber = result?.signupSubscriber
        return {
          subscriberId: subscriber?.id,
          subscriberSignedUp: true,
        };
      } catch (e) {
        return  {
          signupSubscriberError: "Something went wrong, please try again.",
        };
      }
  }

  return { signupSubscriber };
}
